import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "variable-search",
  class: "input-wrapper uk-margin-small"
}
const _hoisted_2 = ["placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_edit_mode_buttons = _resolveComponent("edit-mode-buttons")!

  return (_openBlock(), _createElementBlock("div", {
    id: "variables-buttons-row",
    class: _normalizeClass(["uk-flex uk-margin-small", _ctx.variablesButtonRowClasses()])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("input", {
        class: "uk-input uk-form-small",
        type: "text",
        placeholder: _ctx.$t('shared.template_form.search_bar.placeholder'),
        onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeSearchQueryHandler && _ctx.changeSearchQueryHandler(...args)))
      }, null, 40, _hoisted_2)
    ]),
    (_ctx.editModeAllowed)
      ? (_openBlock(), _createBlock(_component_edit_mode_buttons, {
          key: 0,
          "edit-mode": _ctx.editMode,
          onCreateFolderClicked: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('createFolderClicked'))),
          onSwitchEditModeClicked: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('switchEditModeClicked')))
        }, null, 8, ["edit-mode"]))
      : _createCommentVNode("", true)
  ], 2))
}